import React, { useState, useEffect } from 'react'
import { Input, Col, Row, Form, Checkbox, notification, Select, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';
import RequestHandler from '../../util/RequestHandler';

const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 11,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const TenantPaymentAccountUpdate = (props) => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({ query: '(max-device-width: 1224px)' });

  const [loading, setLoading] = useState(false);
  const [bankId, setbankId] = useState(props.bankId);
  const [iban, setiban] = useState(props.iban);
  const [bankBranchName, setbankBranchName] = useState(props.bankBranchName);
  const [accountNumber, setaccountNumber] = useState(props.accountNumber);
  const [name, setName] = useState(props.name);
  const [isDefault, setisDefault] = useState(props.isDefault);
  const [bankDropdown, setbankDropdown] = useState([]);

  const [bankBranchDropdownUpdate, setbankBranchDropdownUpdate] = useState([]);
  useEffect(() => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${props.bankId}`).then(response => {
      setbankBranchDropdownUpdate(response);
    });

    setbankBranchName(props.bankBranchName);
    setName(props.name);
    setiban(props.iban);
    setisDefault(props.isDefault);

    RequestHandler.get(`/Bank`).then(response => {
      setbankDropdown(response.value.filter(x => x.istosSupport === true));
    });
  }, [setbankDropdown, setbankId, setName, setiban, setisDefault, props.accountNumber, props.name, props.firmDropdown, props.firmId, props.bankId, props.bankDropdown, props.bankBranchName, props.iban, props.isDefault]
  );

  const openNotificationWithIconUpdate = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Güncelleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Ekleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };

  const onFinishAdd = values => {
    RequestHandler.put(`/TenantPaymentAccount`, {
      bankId: props.bankId,
      name: values.Name,
      bankBranchId: values.bankBranchId,
      accountNumber: values.AccountNumber,
      iban: values.Iban,
      isDefault: values.IsDefault === null || values.IsDefault == undefined ? false : values.IsDefault
    }, false, { rawResponse: true }).then(res => {
      if (res.status === 200) {
        openNotificationWithIcon('success');
        setTimeout(function () {
          window.location.reload();
        }.bind(this), 2000);
      }else{
        setLoading(false)
      }
    }).catch(function (e) {
      setLoading(false);
    });
  }

  const onFinishUpdate = values => {
    RequestHandler.put(`/TenantPaymentAccount`, {
      id: props.firmAccountId,
      bankId: props.bankId,
      name: values.Name,
      bankBranchId: values.BankBranchId,
      accountNumber: values.AccountNumber,
      iban: values.Iban,
      isDefault: values.IsDefault
    }, false, { rawResponse: true }).then(res => {
      if (res.status == 200) {
        openNotificationWithIconUpdate('success');
        setTimeout(function () {
          props.sendDataForUpdate("success");
          setLoading(false);
        }.bind(this), 2000);
      }else{
        setLoading(false)
      }
    }).catch(function (e) {
      setLoading(false);
    });
  };

  const onFinishFailedUpdate = () => setLoading(false);

  const handleChecked = (e) => setisDefault(e.target.checked);

  const onChange = (value) => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${value}`).then(response => {
      setbankBranchDropdownUpdate(response);
      setbankId(value);
      setbankBranchName('');
    });
  }

  const handleAccountNumber = value => setaccountNumber(value.target.value);

  const handleName = value => {
    setName(value.target.value)
  };

  const handleBankBranchId = value => setbankBranchName(value);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const handleIban = value => {
    setiban(value.target.value)
  };

  const { Option } = Select;
  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={props.AccountId !== undefined ? onFinishAdd : onFinishUpdate}
        onFinishFailed={onFinishFailedUpdate}
        fields={[
          { name: "Name", value: name },
          { name: "BankId", value: bankId },
          { name: "Iban", value: iban },
          { name: "BankBranchId", value: bankBranchName },
          { name: "AccountNumber", value: accountNumber },
          { name: "IsDefault", value: isDefault },
        ]}
      >
        <Row>
          {isDesktopOrLaptop && <>
            <Col span={24}>
              <Form.Item
                label="Hesap Adı"
                name="Name"
              >
                <Input
                  value={name}
                  onChange={handleName} />
              </Form.Item>

              <Form.Item
                label="Banka"
                name="BankId"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen banka alanını boş bırakmayın.',
                  },
                ]}
              >
                <Select
                  showSearch
                  disabled
                  placeholder="Seçiniz."
                  optionFilterProp="children"
                  onChange={onChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankDropdown.map(item => (
                    item.Name === "KASA HESABI" ? "" :
                      <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="IBAN"
                name="Iban"
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen Iban alanını boş bırakmayın.',
                    },
                  ]}
              >
                <Input type="text" maxLength="26" value={iban} onChange={handleIban} />
              </Form.Item>
              <Form.Item
                label="Banka Şubesi"
                name="BankBranchId"
              >
                <Select
                  showSearch
                  placeholder="Seçiniz"
                  optionFilterProp="children"
                  onChange={handleBankBranchId}
                  value={bankBranchName}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankBranchDropdownUpdate.map(item => (
                    <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Hesap Numarası"
                name="AccountNumber"
              >
                <Input maxLength="17" onInput={maxLengthCheck}
                  value={accountNumber}
                  onChange={handleAccountNumber} />
              </Form.Item>


              <Form.Item
                label="Geçerli Hesap"
                name="IsDefault"
                valuePropName="checked"
              >
                <Checkbox onChange={handleChecked} />
              </Form.Item>
            </Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={3}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  {props.AccountId !== undefined ? "Ekle" : "Güncelle"}
                </Button>
              </Form.Item>
            </Col>
            <Col span={3}></Col>
          </>}
          {isTabletOrMobileDevice && <>
            <Col span={24}>
              <Form.Item
                label="Hesap Adı"
                name="Name"
              >
                <Input
                  value={name}
                  onChange={handleName} />
              </Form.Item>


              <Form.Item
                label="IBAN"
                name="Iban"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen Iban alanını boş bırakmayın.',
                  },
                ]}
              >
                <Input type="text" maxLength="26" value={iban} onChange={handleIban} />
              </Form.Item>

              <Form.Item
                label="Banka Şubesi"
                name="BankBranchId"
              >
                <Select
                  showSearch
                  placeholder="Seçiniz"
                  optionFilterProp="children"
                  onChange={handleBankBranchId}
                  value={bankBranchName}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankBranchDropdownUpdate.map(item => (
                    <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Hesap Numarası"
                name="AccountNumber"
              >
                <Input maxLength="17" onInput={maxLengthCheck}
                  value={accountNumber}
                  onChange={handleAccountNumber} />
              </Form.Item>

              <Form.Item
                label="Geçerli Hesap"
                name="IsDefault"
                valuePropName="checked"
              >
                <Checkbox onChange={handleChecked} />
              </Form.Item>
            </Col>
            <Col span={10}></Col>
            <Col span={8}>
              <Form.Item {...tailLayout} >

                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  {props.AccountId !== undefined ? "Ekle" : "Güncelle"}
                </Button>
              </Form.Item>
            </Col>
            <Col span={6}></Col>
          </>}

        </Row>
      </Form>
    </div>
  )
}

export default TenantPaymentAccountUpdate;